import styled from "styled-components";
import {
  DefaultTitleSmallFactory,
  DefaultTitleLargeFactory,
} from "../Typograph/Typograph.Style";

export const Container = styled.div(({ theme }) => ({
  padding: "40px 20px",
  background: theme.color.neutral["08"],

  [theme.breakpoint.lg()]: {
    padding: "60px 112px",
  },
}));

export const Content = styled.div(() => ({}));

export const TrackTitle = styled.h3(({ theme }) => ({
  ...DefaultTitleSmallFactory({ theme }),
  color: theme.color.neutral["02"],
  marginBottom: `40px`,
}));

export const TrackNumber = styled.span(({ theme }) => ({
  ...DefaultTitleSmallFactory({ theme }),
  color: theme.color.brandSecondary.light,
}));

export const StatusContainer = styled.div(({ currentStep, isCompleted }) => ({
  display: "flex",
  gap: 16,
  opacity: currentStep || isCompleted ? 1 : 0.4,
}));

export const StatusContent = styled.div(() => ({
  display: "flex",
  gap: 8,
}));

export const StatusTitle = styled.h4(({ theme, isCompleted }) => ({
  fontSize: 20,
  fontWeight: 500,
  lineHeight: `150%`,
  display: "flex",
  alignItems: "center",
  gap: 8,
  color: isCompleted ? "#5B8E00" : "#6F7C87",

  [theme.breakpoint.lg()]: {
    fontSize: 24,
  },
}));

export const StatusDescrption = styled.h4(({ theme }) => ({
  fontSize: 18,
  fontWeight: 400,
  lineHeight: `160%`,

  [theme.breakpoint.lg()]: {
    fontSize: 20,
  },
}));

export const StatusList = styled.div(({ theme }) => ({
  [theme.breakpoint.lg()]: {
    display: "flex",
    flexWrap: "wrap",
  },
  marginTop: 40,
}));

export const TrackingTitlePage = styled.h1(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
  margin: "40px 0",
}));

export const Divider = styled.div(({ theme }) => ({
  border: `1px solid ${theme.color.line.medium}`,
  width: "100%",
  margin: "40px 0",
}));
